import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { Field } from "@/modules/FormTemplate/models/Field";
import { Condition } from "@/modules/FormTemplate/models/Condition";
import ConditionalComponent from "../CoditionalComponent/ConditionalComponent.vue";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import { VJSF_OPTIONS } from "@/shared/constants/FormConstants";
import { Utils } from "@/shared/utils/utils";
import { FormSchema } from "@/shared/models/FormSchema";
import HtmlRenderFieldsForm from "@/shared/components/HtmlRenderFieldsForm/HtmlRenderFieldsForm.vue";

Vue.use(Vuetify);

@Component({
  name: "FieldComponent",
  components: {
    EmptyState,
    ConditionalComponent,
    ModifVJsfInput,
    HtmlRenderFieldsForm
  }
})
export default class FieldComponent extends Vue {
  @Prop() private fields!: Field[];
  @Prop() private formConditions!: Condition[];

  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  cardClass = STYLE_CLASSES.CARD;
  FIELD_EMPTY_STATE_HEADER = FORM_TEMP_CONSTANTS.FIELD_LABEL.EMPTY_STATE_HEADER;
  FIELD_EMPTY_STATE_PARAGRAPH =
    FORM_TEMP_CONSTANTS.FIELD_LABEL.EMPTY_STATE_PARAGRAPH;

  EDIT_FIELD =
    FORM_TEMP_CONSTANTS.FIELD_COMPONENT_TOOLTIPS.BTN_TOOLTIPS.EDIT_FIELD;
  DELETE_FIELD =
    FORM_TEMP_CONSTANTS.FIELD_COMPONENT_TOOLTIPS.BTN_TOOLTIPS.DELETE_FIELD;
  ADD_CONDITION =
    FORM_TEMP_CONSTANTS.FIELD_COMPONENT_TOOLTIPS.BTN_TOOLTIPS.ADD_CONDITION;
  VJSF_OPTIONS = VJSF_OPTIONS;

  /** Modelo por fila para campos HTML del preview (evita estado compartido entre índices). */
  htmlPreviewModels: Array<Record<string, unknown>> = [];

  @Watch("fields", { immediate: true, deep: true })
  syncHtmlPreviewModelsLength(): void {
    const n = this.fields?.length ?? 0;
    while (this.htmlPreviewModels.length < n) {
      this.htmlPreviewModels.push({});
    }
    if (this.htmlPreviewModels.length > n) {
      this.htmlPreviewModels.length = n;
    }
  }

  editField(index: number) {
    this.fields[index].model = {};
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.FIELD.EDIT, index);
  }

  deleteField(index: number) {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.FIELD.DELETE, index);
  }

  saveNewFieldOrder() {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.FIELD.SAVE_NEW_ORDER);
  }

  private buildWrappedFieldSchema(index: number): Record<string, unknown> {
    return {
      type: "object",
      properties: {
        field: (this.fields[index].schema as unknown) as Record<string, unknown>
      },
      "x-cols": {
        md: this.fields[index].width
      }
    };
  }

  /** Solo fragmento v-jsf; no mutar estado durante el render. */
  getSchema(index: number): FormSchema {
    const separated = Utils.splitFormSchemaByHtmlDisplay(
      this.buildWrappedFieldSchema(index)
    );
    return separated.vjsfSchema as FormSchema;
  }

  htmlSchemaForField(index: number): FormSchema {
    const separated = Utils.splitFormSchemaByHtmlDisplay(
      this.buildWrappedFieldSchema(index)
    );
    return separated.htmlSchema as FormSchema;
  }

  hasHtmlPreview(index: number): boolean {
    const html = this.htmlSchemaForField(index);
    return Utils.collectFieldKeysFromSchema(html).size > 0;
  }

  openConditionDialog(index: number) {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.CONDITION.ADD_NEW, index);
  }

  show(key: string) {
    const val = this.formConditions.find(
      fc => fc.condition.parentField === key
    );
    if (val !== undefined) {
      return true;
    } else {
      return false;
    }
  }

  modifyCondition(action: string, index: number) {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.CONDITION.MODIFY, action, index);
  }

  modifyConditionalField(action: string, data: any) {
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.CONDITION.FIELD.MODIFY, action, data);
  }
}
